export const homeObjOne = {
    lightBg: false,
    lightText: true,
    lightTextDesc: true,
    topLine:'Explore CodeBanana', // - working correctly
    headline: 'Learn to code in a new way', 
    description: 'Our awesome coding platform lets you visualize code like you’ve never seen before.',
    buttonLabel: 'Get Started',
    imgStart: '',
    img: 'images/2.svg', // need to change the image
    alt: 'CodeBanana'
}

export const homeObjTwo = {
    lightBg: true,
    lightText: false,
    lightTextDesc: false,
    topLine: 'EASY SETUP',
    headline: 'Super Fast and Easy to use',
    description: "Start coding with a click of a button. The no installation feature ensures that you have access anytime, anywhere.",
    buttonLabel: 'Start Now',
    imgStart: 'start',
    img: 'images/3.svg',
    alt: 'Vault'
};

export const homeObjThree = {
    lightBg: false,
    lightText: true,
    lightTextDesc: true,
    topLine: 'Build Projects',
    headline: 'Build actual working projects',
    description:
      'Build user-friendly projects. Get your hands dirty because that is the best way to learn.',
    buttonLabel: 'Learn More',
    imgStart: '',
    img: 'images/1.svg',
    alt: 'Vault'
};
  

  
export const homeObjFour = {
    lightBg: false,
    lightText: true,
    lightTextDesc: true,
    topLine: 'Certificates',
    headline: 'Once you’re done building, get certified',
    description:
      'Although we believe your projects are enough to show your skills, a little showing-off never hurt anyone.',
    buttonLabel: 'Sign Up Now',
    imgStart: 'start',
    img: 'images/4.svg',
    alt: 'Vault'
};
